// extracted by mini-css-extract-plugin
export default {"container":"GlobalNavigationFallback_container__NzRlM","cardsContainer":"GlobalNavigationFallback_cardsContainer__NDViO"};